import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import TableLoaderRow from "~/components/TableView/TableViewLoaderRow";
import { TABLE_ROW_HEIGHT as TABLE_ROW_HEIGHT_BASE } from "~/components/TableView/ui";
export const TABLE_ROW_GAP = 8;
export const TABLE_ROW_HEIGHT = TABLE_ROW_HEIGHT_BASE + TABLE_ROW_GAP;
export const MOBILE_TABLE_ROW_HEIGHT = 80;
export const TABLE_LOADER_ROW_HEIGHT = 200;
export const getLoaderRow = (isLoading, loadMore)=>({
        height: TABLE_LOADER_ROW_HEIGHT,
        // eslint-disable-next-line react/display-name
        render: (rowStyle, key, isVisible)=>/*#__PURE__*/ _jsx(TableLoaderRow, {
                loadMore: loadMore,
                isLoading: isLoading,
                isVisible: isVisible,
                style: rowStyle
            }, key)
    });
